import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('is mini program', this.#isMiniProgram)
    if(this.#isMiniProgram) {
      this.element.classList.remove('hidden')
    } else {
      this.element.classList.add('hidden')
    }
  }

  login(_event){
    window.wx.miniProgram.postMessage({
      data: {
        action: 'login'
      }
    })
  }

  get #isMiniProgram() {
    return window.__wxjs_environment === 'miniprogram'
  }
}
